<template>
  <div class="container-fluid event-ticketing">
    <!-- Header Section -->

    <div class="row header d-flex justify-content-between bg-white align-items-center px-0 no-gutters px-xl-3 py-3">
      <div class="d-flex justify-content-between-mobile align-items-center-mobile">
        <router-link to="/"
          class="col-md-6 d-flex align-items-center text-decoration-none justify-content-between-mobile">
          <div class="text-center border-right me-0 pe-0 me-md-3 pe-md-3 mb-0 mb-md-0">
            <img class="ticketing-logo" src="../assets/images/nea-ionia-logo.png" alt="">
          </div>
          <div class="header-title fw-bold">
            <h5 class="header-line2">ΠΛΑΤΦΟΡΜΑ ΔΙΑΧΕΙΡΙΣΗΣ</h5>
            <h5 class="header-line2">ΗΛΕΚΤΡΟΝΙΚΟΥ ΕΙΣΙΤΗΡΙΟΥ</h5>
          </div>
        </router-link>
        <div class="col-md-6  align-items-center d-flex justify-content-end justify-content-center-mobile pt-3 pt-xl-0"
          v-if="loaded && !user">
          <router-link to="/login">
            <a class="btn btn-login fw-bold fs-6 me-2 d-flex align-items-center gap-2" id="loginBtn">Είσοδος <img
                src="../assets/images/login-b.png" alt="" width="24"></a>
          </router-link>

          <router-link to="/register">
            <a class="btn fs-6 btn-register">Εγγραφή</a>
          </router-link>
        </div>
        <div class="col-md-6 welcome-wrap justify-content-end align-items-center gap-md-1" v-if="loaded && user">
          <div class="welcome-user-wrap text-end me-2">
            <span class="fs-sm">
              Συνδεδεμένος ως •
              <b>{{ user?.name }}</b>
            </span>
          </div>
          <!-- Dropdown -->
          <div class="dropdown user-profile-button">
            <button class="btn p-0 border-0 bg-transparent" type="button" data-bs-toggle="dropdown"
              aria-expanded="false">
              <img src="../assets/images/profile.png" alt="Profile" width="28" class="rounded-circle">
            </button>
            <ul class="dropdown-menu dropdown-menu-end bg-white">
              <li v-if="user?.usertype_id == '1'">
                <router-link class="dropdown-item" to="/events">
                  Διαχειριστικό πάνελ
                </router-link>
              </li>
              <li v-if="user?.usertype_id != '1'">
                <router-link class="dropdown-item" to="/tickets">
                  Τα εισιτήριά μου
                </router-link>
              </li>
              <li>
                <router-link class="dropdown-item" to="/account">
                  Προσωπικά Στοιχεία
                </router-link>
              </li>
              <li>
                <router-link class="dropdown-item" to="/change-password">
                  Αλλαγή κωδικού
                </router-link>
              </li>
              
              <li v-if="user?.usertype_id != '1'">
                <router-link class="dropdown-item" to="/#">
                  Όροι & προϋποθέσεις
                </router-link>
              </li>
              <li v-if="user?.usertype_id != '1'">
                <router-link class="dropdown-item" to="/contact">
                  Επικοινωνία
                </router-link>
              </li>

              <li>


                <hr class="dropdown-divider">
              </li>
              <li>
                <button class="dropdown-item" id="logoutBtn">
                  Αποσύνδεση
                </button>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div class="filter-toggle-wrap" v-if="$route.name === 'Home'">
        <button class="toggle-filter" @click="toggleFilter">
          <span>Φίλτρα</span>
          <img src="../assets/images/filter.png" alt="" width="22">
          <!-- <span class="fa fa-bars menuIcon"></span> -->
        </button>
      </div>
    </div>

    <div v-if="cartCount > 0 && $route.name !== 'Cart'" class="main-cart-wrap">
      <router-link to="/cart">
        <img src="../assets/images/cart-icon.png" class="main-cart">
        <div class="cart-bubble">
          {{ cartCount }}
        </div>
      </router-link>
    </div>




    <slot />
  </div>
</template>

<script setup>
import { ref, onMounted, watch, computed, provide, onUnmounted } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { login } from '../services/auth';
import { fetchUserInfo } from '../services/user';
import { fetchCartCount } from '../services/cart.js';
import { useStore } from 'vuex'

defineProps({
  categories: Array,
  activeCategory: Number
});

const currentIndex = ref(0);
const cartCount = ref(0);
provide('cartCount', cartCount);


const showSearch = ref(true);
const categories = ref([]);
const loginData = ref({
  email: '',
  password: ''
});
const errorMessage = ref(false);
const user = ref(null);
const loaded = ref(false)
const isFilterOpen = ref(false)
const store = useStore()


const route = useRoute();
const router = useRouter();

function toggleFilter() {
  store.commit('toggleFilter');
}


provide('isFilterOpen', isFilterOpen)
provide('toggleFilter', toggleFilter)

const handleCarouselLoop = () => {
  if (currentIndex.value >= categories.value.length - 1) {
    currentIndex.value = 0;
  } else if (currentIndex.value < 0) {
    currentIndex.value = categories.value.length - 1;
  }
};

const updateSearchVisibility = () => {
  showSearch.value = !route.path.includes('/register');
};


const loginUser = async () => {
  try {
    const response = await login(loginData.value.email, loginData.value.password);
    if (response.data?.success) {
      if (response.data?.data?.token?.plainTextToken) {
        localStorage.setItem('api_token', response.data?.data?.token?.plainTextToken);
      }
      errorMessage.value = false;
      setTimeout(() => {
        if (route.path.includes('/register')) {
          window.location.href = '/';
        } else if (response.data.data.info.usertype_id === 3) {
          window.location.href = '/?category_id=0';
        } else {
          window.location.reload();
        }
      }, 300);
    } else {
      errorMessage.value = "Λάθος στοιχεία σύνδεσης";
    }
  } catch (e) {
    errorMessage.value = "Λάθος στοιχεία σύνδεσης";
  }
};

const loadUser = async () => {
  const res = await fetchUserInfo()
  user.value = res.data?.info ?? null
  loaded.value = true
}

watch(currentIndex, handleCarouselLoop);
watch(route, updateSearchVisibility);

onMounted(async () => {
  window.addEventListener('auth-changed', loadUser)
  updateSearchVisibility();
  const userInfoResponse = await fetchUserInfo();
  if (userInfoResponse.data) {
    user.value = userInfoResponse.data?.info;
  }


  // await loadUser()

  loaded.value = true;

  const updateCart = async () => {
    if (user.value) {
      const fetchCount = await fetchCartCount();
      if (fetchCount?.data?.cart_count !== undefined) {
        cartCount.value = fetchCount.data.cart_count;
      }
    }
  };


  onUnmounted(() => {
    window.removeEventListener('auth-changed', loadUser)
  })





  // Initial fetch
  await updateCart();

  // Refresh cart count every 1 minute (60000ms)
  const cartInterval = setInterval(updateCart, 60000);

  // Cleanup on unmount
  onUnmounted(() => clearInterval(cartInterval));

  document.body.addEventListener('click', (e) => {
    if (e.target && e.target.id === 'loginBtn') {
      e.preventDefault();
    } else if (e.target && e.target.id === 'logoutBtn') {
      e.preventDefault();
      localStorage.removeItem('api_token');
      setTimeout(() => {
        window.location.href = '/';
      }, 300);
    }
  });
});

</script>


<style scoped>
.carousel-container:active {
  cursor: grabbing;
}

.header {
  box-shadow: 0px 0px 5px 0px #dedede;
  z-index: 2;
}

.header-line {
  font-size: 1.6rem;
  margin: 0;
  color: #656236;
  font-weight: bold;
  text-shadow: 0px 1px #656236;
}

.header-line2 {
  color: #707070;
  margin-bottom: 0px;
}

.border-right {
  border-right: 2px solid #6c6c6c !important;
}

.search-input-container {
  position: relative;
  width: 80%;
}

#main-search-input {
  padding-right: 2.5rem;
}

.btn.active {
  border: 0px;
  border-radius: 0px;
  border-bottom: 2px solid var(--primary-color);
  color: var(--primary-color);
}

.searchIcon {
  position: absolute;
  top: 50%;
  right: 40px;
  transform: translateY(-50%);
  color: #66623E;
  font-size: 1.2rem;
  cursor: pointer;
  pointer-events: none;
}

@keyframes pulse {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.1); /* Expands the cart */
  }
  100% {
    transform: scale(1);
  }
}

.main-cart-wrap {
  position: fixed;
  bottom: 40px;
  right: 20px;
  width: 50px;
  height: 50px;
  background: #fff;
  border-radius: 12px;
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12);
  cursor: pointer;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  z-index: 1000;
  animation: pulse 4s infinite;
}

.main-cart-wrap:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.18);
}

.main-cart {
  position: relative;
  right: 1px;
  width: 100%;
  padding: 9px
}

.cart-bubble {
  position: absolute;
  top: 6px;
  right: 6px;
  background: #af0036;
  color: #fff;
  font-size: 12px;
  font-weight: 600;
  min-width: 18px;
  height: 18px;
  padding: 0 4px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  line-height: 1;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.2);
}

.account-wrap,
.welcome-wrap {
  display: flex;
}

.filter-toggle-wrap {
  display: none;
}

.ticketing-logo {
  /* width: 160px; */
  height: 85px
}

.toggle-filter {
  border: none;
  background: none;
  font-size: 18px;
}

.header-title-mobile {
  display: none;
}

.user-profile-button {
  border: 1px solid #2b2b2b;
  border-radius: 100%;
  padding: 5px;
  cursor: pointer;
}



@media (max-width: 1199px) {

  .filter-toggle-wrap {
    display: block;
    background: white;
    max-width: -moz-fit-content;
    max-width: fit-content;
    position: fixed;
    bottom: 50px;
    left: 10px;
    z-index: 20;
    border-radius: 8px;
    box-shadow: 0px 0px 10px 0px #b9b9b9;
    padding: 2px 5px;
  }

  .header-title {
    display: none;
  }

  .header-title-mobile {
    display: unset;
  }
}

@media (max-width: 576px) {
  .header-title {
    margin-left: 8px;
    text-align: left;
  }

  .welcome-wrap {
    /* display: block; */
    text-align: center;
  }

  .welcome-user-wrap {
    display: unset;
  }

  .btn-account {
    margin-top: 5px;
  }

  .main-cart-wrap {
    right: 5px;
    bottom: 30px;
  }

  .btn-logout {
    position: relative;
    top: 2px;
  }

  .header-line2 {
    font-size: 16px;
    text-align: center;
    color: #3a3a3a;
  }

  .ticketing-logo {
    /* width: 130px; */
    height: 75px;
  }

  .border-right {
    border-right: 0px !important;
  }
}
</style>